import React from 'react'
import UpperFilter from './UpperFilter'
import VideoContainer from './VideoContainer'

const VideoSection = () => {
  return (
    <div id="videoSection">
        <UpperFilter/>

        <VideoContainer/>
    </div>
  )
}

export default VideoSection